import React, { createContext, useState, useContext } from 'react';

const UIContext = createContext();

export const useUI = () => useContext(UIContext);

export const UIProvider = ({ children }) => {
    const [isBidFormOpen, setIsBidFormOpen] = useState(false);
    const [editingBid, setEditingBid] = useState(null);

    const [dashboardRefreshCount, setDashboardRefreshCount] = useState(0);
    const triggerDashboardRefresh = () => setDashboardRefreshCount(c => c + 1);

    const [calendarRefreshCount, setCalendarRefreshCount] = useState(0);
    const triggerCalendarRefresh = () => setCalendarRefreshCount(c => c + 1);

    const openNewBidForm = () => {
        setEditingBid(null);
        setIsBidFormOpen(true);
    };

    const openEditBidForm = (bid) => {
        setEditingBid(bid);
        setIsBidFormOpen(true);
    };

    const closeBidForm = () => {
        setIsBidFormOpen(false);
        setEditingBid(null);
    };

    const value = {
        isBidFormOpen,
        editingBid,
        openNewBidForm,
        openEditBidForm,
        closeBidForm,
        dashboardRefreshCount,
        triggerDashboardRefresh,
        calendarRefreshCount,
        triggerCalendarRefresh,
    };

    return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};